import { useTranslation } from "react-i18next";
import { Button, ExitIcon } from "../index";
import "./Modal.scss";

interface ModalProps {
  handleCloseModal: () => void;
  lKeyHeader: string;

  lKeySubmitButton: string;
  lKeyCancelButton: string;
  lKeyMainText?: string;
  lKeyAdditionalText?: string;
  handleSubmit: () => void;
  loading?: boolean;
  className?: string;
}

export const Modal = ({
  className = "",
  handleCloseModal,
  lKeyHeader,
  handleSubmit,
  lKeyCancelButton,
  lKeySubmitButton,
  lKeyAdditionalText,
  lKeyMainText,
  loading = false,
}: ModalProps) => {
  const { t } = useTranslation();
  return (
    <section className={`modal-container opened ${className}`}>
      <dialog open={true} className="modal">
        <header>
          <h2>{t(`${lKeyHeader}`)}</h2>
          <button onClick={handleCloseModal} data-testid="close-button">
            <ExitIcon />
          </button>
        </header>
        <main>
          {lKeyMainText ? <p className="main-text">{t(lKeyMainText)}</p> : <></>}
          {lKeyAdditionalText ? <p className="additional-text">{t(lKeyAdditionalText)}</p> : <></>}
          <div className="buttons-container">
            <Button
              className="cancel-button"
              isDisabled={false}
              lKey={lKeyCancelButton}
              onClick={handleCloseModal}
              type="button"
            />
            <Button
              className="submit-button"
              isDisabled={false}
              lKey={lKeySubmitButton}
              onClick={handleSubmit}
              type="button"
              isLoading={loading}
            />
          </div>
        </main>
      </dialog>
    </section>
  );
};
